import React, { Component } from 'react';
import { Button, Input, Form, Modal } from 'antd';
import '../Login.css';

const { TextArea } = Input;

class LicenceUpload extends Component {
  state = {
    visible: true,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { handleIsLicensed } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.updateLicenseKey({
          data: values,
          callback: () => {
            handleIsLicensed();
            this.setState({
              visible: false,
            });
          },
        });
      }
    });
  };

  render() {
    const { form, licenseExpired } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Modal
        title="License Activation"
        width="445px"
        visible={this.state.visible}
        className="licencePopup"
        closable={false}
        centered
        onOk={this.handleSubmit}
        footer={[
          <Button className="addButton" onClick={this.handleSubmit}>
            Submit
          </Button>,
        ]}
      >
        <Form
          onSubmit={this.handleSubmit}
          style={{
            width: '100%',
          }}
        >
          {licenseExpired &&
            !licenseExpired.isLicenseValid &&
            !licenseExpired.isFirstVerification && (
              <span className="expiredInfo">
                <span className="expiredInfoIcon flaticon-info" />
                Your license has expired. Please enter the new license key to
                continue.
              </span>
            )}
          <Form.Item className="loginFormField">
            <span className="loginLabel">License Key</span>
            {getFieldDecorator('productKey', {
              rules: [
                {
                  required: true,
                  message: 'Enter license key',
                },
              ],
            })(
              <TextArea
                autoComplete="off"
                rows={4}
                autosize={{
                  minRows: 2,
                  maxRows: 6,
                }}
                placeholder="Enter license key"
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default LicenceUpload;
